var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.92a6.232 6.232 0 01-1.769.478 3.046 3.046 0 001.354-1.676 6.239 6.239 0 01-1.955.734 3.093 3.093 0 00-2.245-.956c-1.7 0-3.078 1.356-3.078 3.03 0 .236.028.467.08.69a8.785 8.785 0 01-6.343-3.166 2.982 2.982 0 00-.416 1.523c0 1.051.542 1.979 1.369 2.523a3.112 3.112 0 01-1.395-.38v.038c0 1.469 1.062 2.692 2.468 2.972a3.125 3.125 0 01-1.39.05 3.079 3.079 0 002.875 2.105 6.231 6.231 0 01-3.822 1.296c-.249 0-.493-.014-.733-.042A8.795 8.795 0 004.717 13.5c5.66 0 8.756-4.616 8.756-8.619 0-.131-.003-.263-.008-.392A6.203 6.203 0 0015 2.92z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

export default SvgCommonIconTwitter;